var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAlert)?_c('b-alert',{attrs:{"variant":_vm.alertVariant,"show":_vm.dismissCountDown,"dismissible":_vm.dismissible},on:{"dismiss-count-down":_vm.countDownChanged,"dismissed":_vm.resetData}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }